import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Search, ExternalLink, Filter, ChevronRight, Menu, X, ArrowUpRight, Loader2, MessageSquareText, Sparkles, ShieldCheck, Zap, ChevronDown, SlidersHorizontal, ArrowDownAZ } from 'lucide-react';

const BUILD_PRODUCTS = [
  {
    id: 1, resourceId: "85498",
    title: "WoolWars Arenas | Medieval Feel",
    description: "Level Up WoolWars Fast With These Modern, Ready-To-Use Maps!",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/woolwars-banner-png.1127021/?preset=cardr1",
    link: "https://builtbybit.com/resources/woolwars-arenas-medieval-feel.85498/"
  },
  {
    id: 2, resourceId: "87856",
    title: "Fantasy Lobby | Minigames Hub 100x100",
    description: "Fantasy minigame lobby with NPC hub and leaderboard zones, compact and adaptable.",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/fantasylobby_thumbnail-png.1246894/?preset=cardr1",
    link: "https://builtbybit.com/resources/fantasy-lobby-minigames-hub-100x100.87856/"
  },
  {
    id: 3, resourceId: "87864",
    title: "Farm CTF Arena | Capture the Flag",
    description: "A farm-themed arena built for Capture the Flag, also ideal for fast-paced 1v1 PvP.",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/ctf-arena1-png.1150750/?preset=cardr1",
    link: "https://builtbybit.com/resources/farm-ctf-arena-capture-the-flag.87864/"
  },
  {
    id: 4, resourceId: "90824",
    title: "PvP Arenas | 3 Large PvP Maps",
    description: "Three large fantasy-medieval PvP arenas built for paintball, also suitable for 1v1 and team-based.",
    price: 5.49, categories: ["Arenas"],
    imageUrl: "https://builtbybit.com/attachments/arrrow-builds-jpg.1253466/?preset=cardr1",
    link: "https://builtbybit.com/resources/pvp-arenas-3-large-pvp-maps.90824/"
  },
  {
    id: 5, resourceId: "95936",
    title: "PvP Arenas | FFA Style",
    description: "2 Amazing FFA Arenas, Grass & Desert Biomes. Built for 1.21 Modern PvP!",
    price: 3.99, categories: ["Arenas"],
    imageUrl: "https://builtbybit.com/attachments/x2ffathumb-png.1222440/?preset=cardr1",
    link: "https://builtbybit.com/resources/pvp-arenas-ffa-style.95936/"
  },
  {
    id: 6, resourceId: "100790",
    title: "Jungle Minigame Lobby | 11 NPC Slots",
    description: "An amazing Jungle Themed lobby for Minigames with 11 NPCs, 3 crates, and a space for leaderboard.",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/jungle_lobby_thumbnail-png.1269759/?preset=cardr1",
    link: "https://builtbybit.com/resources/jungle-minigame-lobby-11-npc-slots.100790/"
  },
  {
    id: 7, resourceId: "95313",
    title: "Soccer Stadium | Modern Minecraft",
    description: "An amazing 100x100 Soccer/Football Stadium built in Modern Minecraft for enhanced experience!",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/soccer_thumbnail-png.1217239/?preset=cardr1",
    link: "https://builtbybit.com/resources/soccer-stadium-modern-minecraft.95313/"
  },
  {
    id: 8, resourceId: "85213",
    title: "TNT Tag Arenas | Futuristic & Medieval",
    description: "Professional 100x100 arenas featuring futuristic and medieval designs for 1.20+",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/tnt-tag-banner-png.1125496/?preset=cardr1",
    link: "https://builtbybit.com/resources/tnt-tag-arenas-futuristic-medieval.85213/"
  },
  {
    id: 9, resourceId: "94076",
    title: "PvP Arena | Large Cave Style",
    description: "Amazing Red vs Blue Cave Styled Medieval PvP Arena best suited for you!",
    price: 3.99, categories: ["Arenas"],
    imageUrl: "https://builtbybit.com/attachments/pb2arenabanner-png.1205413/?preset=cardr1",
    link: "https://builtbybit.com/resources/pvp-arena-large-cave-style.94076/"
  },
  {
    id: 10, resourceId: "100792",
    title: "Tower Defense Arena | Roblox Inspired",
    description: "An Roblox Inspired Tower Defense Arena, built for the amazing Tower Defense X Minigame!",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/td_arena_thumbnail-png.1269757/?preset=cardr1",
    link: "https://builtbybit.com/resources/tower-defense-arena-roblox-inspired.100792/"
  },
  {
    id: 11, resourceId: "99498",
    title: "Pillars of Fortune Arenas - x4 Maps",
    description: "4 Unique Lucky Pillars Arenas with 8, 12 & 16 Pillar Variants - Minigame Ready - 1.20.4+",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/pof_thumb-png.1257923/?preset=cardr1",
    link: "https://builtbybit.com/resources/pillars-of-fortune-arenas-x4-maps.99498/"
  },
  {
    id: 12, resourceId: "98541",
    title: "Soccer Lobby | Sports Themed",
    description: "A soccer-themed lobby featuring a football pitch, stadium stands, 10 NPC stands & a leaderboard area.",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/soccerspawn_thumb-png.1246896/?preset=cardr1",
    link: "https://builtbybit.com/resources/soccer-lobby-sports-themed.98541/"
  },
  {
    id: 13, resourceId: "97965",
    title: "BlockSumo Arenas | x3 Different Types",
    description: "Amazing BlockSumo Arenas built in 1.20, made specifically for the minigame called BlockSumoPro!",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/blocksumo_thumb-png.1242343/?preset=cardr1",
    link: "https://builtbybit.com/resources/blocksumo-arenas-x3-different-types.97965/"
  },
  {
    id: 14, resourceId: "86080",
    title: "Domination Arena | Medieval Feel",
    description: "Amazing Team vs Team Domination Arena in Modern Minecraft.",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/domination-map-png.1132716/?preset=cardr1",
    link: "https://builtbybit.com/resources/domination-arena-medieval-feel.86080/"
  },
  {
    id: 15, resourceId: "86789",
    title: "Mystic Survival Spawn | Dark Modern",
    description: "A modern 1.20 survival spawn built with a dark mystic theme and clean, atmospheric design.",
    price: 3.99, categories: ["Spawn", "Survival"],
    imageUrl: "https://builtbybit.com/attachments/mysticsurvivalbanner-png.1140091/?preset=cardr1",
    link: "https://builtbybit.com/resources/mystic-survival-spawn-dark-modern.86789/"
  },
  {
    id: 16, resourceId: "95153",
    title: "Fireball Fight Arena | Modern Minecraft",
    description: "An amazing Fireball Fight Arena built in modern minecraft to suit your needs!",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/fireball-fight-thumbnail-png.1215880/?preset=cardr1",
    link: "https://builtbybit.com/resources/fireball-fight-arena-modern-minecraft.95153/"
  },
  {
    id: 17, resourceId: "91823",
    title: "Minigame Lobby | Ice Themed | 5 NPC Slot",
    description: "A stunning 1.21.8 Ice Lobby design. Expertly structured and built, featuring 5 NPC slots.",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/21540-png.1250054/?preset=cardr1",
    link: "https://builtbybit.com/resources/minigame-lobby-ice-themed-5-npc-slot.91823/"
  },
  {
    id: 18, resourceId: "91193",
    title: "Minigame Lobby 2 | Sci-Fi | 7 NPC Slots",
    description: "A Hide & Seek Oriented Lobby designed for server spawns, built in Minecraft 1.12.2",
    price: 4.49, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/hs_lobby-png.1184604/?preset=cardr1",
    link: "https://builtbybit.com/resources/minigame-lobby-2-sci-fi-7-npc-slots.91193/"
  },
  {
    id: 19, resourceId: "90717",
    title: "Minigame Lobby | Paintball Themed",
    description: "A vibrant paintball-themed lobby featuring 5 NPC slots, 2 leaderboard areas, and detailed miniatures.",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/2-png.1178021/?preset=cardr1",
    link: "https://builtbybit.com/resources/minigame-lobby-paintball-themed.90717/"
  },
  {
    id: 20, resourceId: "87857",
    title: "Dark Fantasy Warzone Arena | 100x100",
    description: "A dark magical PvP warzone with themed walls and a hot air balloon spawn.",
    price: 3.99, categories: ["Arenas"],
    imageUrl: "https://builtbybit.com/attachments/arrowbuilds-png.1149505/?preset=cardr1",
    link: "https://builtbybit.com/resources/dark-fantasy-warzone-arena-100x100.87857/"
  },
  {
    id: 21, resourceId: "89624",
    title: "Minigame Lobby | Well-Made | 7 NPC Slots",
    description: "A Squid Game-themed lobby designed for server spawns, built in Minecraft 1.21.8",
    price: 3.99, categories: ["Lobby/Hub"],
    imageUrl: "https://builtbybit.com/attachments/squidgamelobby-banner-png.1166309/?preset=cardr1",
    link: "https://builtbybit.com/resources/minigame-lobby-well-made-7-npc-slots.89624/"
  },
  {
    id: 22, resourceId: "89149",
    title: "Mystic Voting Area - Enchanted Realm",
    description: "A beautifully crafted mystic-themed voting area with four enchanted NPC slots.",
    price: 3.99, categories: ["Misc"],
    imageUrl: "https://builtbybit.com/attachments/1-png.1178015/?preset=cardr1",
    link: "https://builtbybit.com/resources/mystic-voting-area-enchanted-realm.89149/"
  },
  {
    id: 23, resourceId: "86626",
    title: "BedWars Arenas | Medieval & Aquatic",
    description: "Two themed BedWars arenas featuring medieval and aquatic designs for Minecraft 1.12.",
    price: 3.99, categories: ["Arenas", "Minigames"],
    imageUrl: "https://builtbybit.com/attachments/bedwars2arenas-png.1138183/?preset=cardr1",
    link: "https://builtbybit.com/resources/bedwars-arenas-medieval-aquatic.86626/"
  }
];

const CATEGORIES = ["All", "Arenas", "Minigames", "Lobby/Hub", "Spawn", "Survival", "Misc", "Skyblock", "KOTH"];
const PRICE_MAX = 10;

function AnimatedStat({ value, label }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  useEffect(() => {
    if (!visible) return;
    const num = parseInt(value.replace(/\D/g, ''));
    if (isNaN(num)) return;
    let s = 0; const step = Math.ceil(num / 75);
    const t = setInterval(() => { s += step; if (s >= num) { setCount(num); clearInterval(t); } else setCount(s); }, 16);
    return () => clearInterval(t);
  }, [visible, value]);
  const n = parseInt(value.replace(/\D/g, '')), suf = value.replace(/[0-9]/g, '');
  return (<div ref={ref} className="stat-item"><span className="stat-number">{isNaN(n) ? value : `${count}${suf}`}</span><span className="stat-label">{label}</span></div>);
}

export default function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [priceRange, setPriceRange] = useState([0, PRICE_MAX]);
  const [sortOrder, setSortOrder] = useState("default");
  const [showResults, setShowResults] = useState(true);
  const [stats, setStats] = useState(null);
  const filterRef = useRef(null);

  const profileImageUrl = "https://images.reavermc.club/Admiralbutterfly/arrowboipfp.png";
  const builtByBitLink = "https://builtbybit.com/creators/zarrowtan.266894/";
  const discordLink = "https://discord.arrowtan.cc";

  useEffect(() => { setLoaded(true); document.title = "Arrow Builds | Premium Minecraft Maps"; }, []);
  useEffect(() => { const h = () => setIsScrolled(window.scrollY > 30); window.addEventListener('scroll', h); return () => window.removeEventListener('scroll', h); }, []);

  // Fetch live stats from stats.json (generated by cron)
  useEffect(() => {
    fetch('/stats.json')
      .then(r => { if (r.ok) return r.json(); throw new Error('No stats'); })
      .then(data => setStats(data))
      .catch(() => setStats(null)); // Silently fail - cards just won't show purchase count
  }, []);

  // Helper to get purchase count for a resource
  const getPurchases = (resourceId) => {
    if (!stats || !stats.resources || !stats.resources[resourceId]) return null;
    return stats.resources[resourceId].purchase_count;
  };

  // Total purchases for hero stat
  const totalPurchases = stats ? stats.total_purchases : null;

  const displayedBuilds = useMemo(() => {
    let f = BUILD_PRODUCTS.filter(b => {
      const s = b.title.toLowerCase().includes(searchQuery.toLowerCase()) || b.description.toLowerCase().includes(searchQuery.toLowerCase());
      const c = activeCategory === "All" || b.categories.includes(activeCategory);
      const p = b.price >= priceRange[0] && b.price <= priceRange[1];
      return s && c && p;
    });
    if (sortOrder === "low") f.sort((a, b) => a.price - b.price);
    else if (sortOrder === "high") f.sort((a, b) => b.price - a.price);
    else if (sortOrder === "popular") {
      f.sort((a, b) => {
        const pa = getPurchases(a.resourceId) || 0;
        const pb = getPurchases(b.resourceId) || 0;
        return pb - pa;
      });
    }
    return f;
  }, [searchQuery, activeCategory, priceRange, sortOrder, stats]);

  useEffect(() => {
    setShowResults(false);
    clearTimeout(filterRef.current);
    filterRef.current = setTimeout(() => setShowResults(true), 250);
    return () => clearTimeout(filterRef.current);
  }, [searchQuery, activeCategory, priceRange, sortOrder]);

  const hasFilters = activeCategory !== "All" || priceRange[0] > 0 || priceRange[1] < PRICE_MAX || sortOrder !== "default";
  const clearAll = () => { setActiveCategory("All"); setPriceRange([0, PRICE_MAX]); setSortOrder("default"); setSearchQuery(""); };

  return (
    <div className="app-root">
      {/* NAV */}
      <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''}`}>
        <div className="nav-inner">
          <a href="#" className="logo-group">
            <div className="logo-avatar"><img src={profileImageUrl} alt="Logo" /></div>
            <span className="logo-text">ARROW<span className="accent">BUILDS</span></span>
          </a>
          <div className="nav-links">
            <a href="#store" className="nav-link">Catalog</a>
            <a href={discordLink} target="_blank" rel="noreferrer" className="nav-link">Commissions</a>
            <a href={builtByBitLink} target="_blank" rel="noreferrer" className="nav-cta">BuiltByBit <ArrowUpRight size={15} strokeWidth={2.5} /></a>
          </div>
          <button className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        <div className={`mobile-menu ${mobileMenuOpen ? 'mobile-menu--open' : ''}`}>
          <a href="#store" onClick={() => setMobileMenuOpen(false)} className="mobile-menu-link">Catalog</a>
          <a href={discordLink} target="_blank" rel="noreferrer" onClick={() => setMobileMenuOpen(false)} className="mobile-menu-link">Commissions</a>
          <a href={builtByBitLink} target="_blank" rel="noreferrer" className="mobile-menu-cta">Visit BuiltByBit <ArrowUpRight size={15} /></a>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg"><div className="hero-grain" /><div className="hero-glow hero-glow--1" /><div className="hero-glow hero-glow--2" /><div className="hero-grid" /></div>
        <div className={`hero-content ${loaded ? 'hero-content--visible' : ''}`}>
          <div className="hero-badge"><span className="hero-badge-dot" />Trusted by 1,000+ Server Owners</div>
          <h1 className="hero-title">
            <span className="hero-title-line">Server Builds That</span>
            <span className="hero-title-line hero-title-accent">Players Remember.</span>
          </h1>
          <p className="hero-subtitle">Premium hubs, arenas & spawns — optimized for performance, designed to leave an impression.</p>
          <div className="hero-actions">
            <a href="#store" className="btn btn--primary">Browse Catalog <ChevronDown size={16} /></a>
            <a href={discordLink} target="_blank" rel="noreferrer" className="btn btn--ghost"><MessageSquareText size={16} /> Request Custom Build</a>
          </div>
          <div className="hero-stats">
            <AnimatedStat value="100+" label="Resources Published" />
            <div className="stat-divider" />
            <AnimatedStat value={totalPurchases ? `${totalPurchases}+` : "1000+"} label="Total Sales" />
            <div className="stat-divider" />
            <AnimatedStat value="5+" label="Years Experience" />
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <div className="trust-bar">
        <div className="trust-track">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="trust-set">
              <span className="trust-item"><Sparkles size={14} /> High Quality Builds</span><span className="trust-sep">✦</span>
              <span className="trust-item"><Zap size={14} /> Instant Delivery</span><span className="trust-sep">✦</span>
              <span className="trust-item"><ShieldCheck size={14} /> Lifetime Support</span><span className="trust-sep">✦</span>
              <span className="trust-item"><Sparkles size={14} /> Performance Optimized</span><span className="trust-sep">✦</span>
              <span className="trust-item"><Zap size={14} /> Plug & Play Setup</span><span className="trust-sep">✦</span>
            </div>
          ))}
        </div>
      </div>

      {/* STORE */}
      <section id="store" className="store">
        <div className="store-inner">
          <aside className="sidebar">
            <div className="sidebar-card">
              <h3 className="sidebar-heading"><Filter size={14} /> Categories</h3>
              <div className="category-list">
                {CATEGORIES.map(cat => {
                  const count = cat === "All" ? BUILD_PRODUCTS.length : BUILD_PRODUCTS.filter(b => b.categories.includes(cat)).length;
                  return (
                    <button key={cat} onClick={() => setActiveCategory(cat)} className={`category-btn ${activeCategory === cat ? 'category-btn--active' : ''}`}>
                      <span>{cat}</span>
                      <span className="cat-count">{count}</span>
                    </button>
                  );
                })}
              </div>

              <div className="sidebar-section">
                <h3 className="sidebar-heading"><SlidersHorizontal size={14} /> Price Range</h3>
                <div className="price-display">
                  <span className="price-badge">${priceRange[0].toFixed(2)}</span>
                  <span className="price-sep">—</span>
                  <span className="price-badge">{priceRange[1] >= PRICE_MAX ? `$${PRICE_MAX}+` : `$${priceRange[1].toFixed(2)}`}</span>
                </div>
                <div className="range-row">
                  <label className="range-label">Min</label>
                  <input type="range" min="0" max={PRICE_MAX} step="0.25" value={priceRange[0]}
                    onChange={e => setPriceRange([Math.min(+e.target.value, priceRange[1]), priceRange[1]])} className="range-slider" />
                </div>
                <div className="range-row">
                  <label className="range-label">Max</label>
                  <input type="range" min="0" max={PRICE_MAX} step="0.25" value={priceRange[1]}
                    onChange={e => setPriceRange([priceRange[0], Math.max(+e.target.value, priceRange[0])])} className="range-slider" />
                </div>
              </div>

              <div className="sidebar-section">
                <h3 className="sidebar-heading"><ArrowDownAZ size={14} /> Sort By</h3>
                <div className="sort-group">
                  {[{ key: "default", label: "Default" }, { key: "popular", label: "Most Popular" }, { key: "low", label: "Price: Low → High" }, { key: "high", label: "Price: High → Low" }].map(o => (
                    <button key={o.key} onClick={() => setSortOrder(o.key)} className={`sort-btn ${sortOrder === o.key ? 'sort-btn--active' : ''}`}>{o.label}</button>
                  ))}
                </div>
              </div>

              <div className="sidebar-footer">
                <p className="sidebar-footer-label">Need something custom?</p>
                <a href={discordLink} target="_blank" rel="noreferrer" className="sidebar-footer-btn">Get in Touch</a>
              </div>
            </div>
          </aside>

          <main className="catalog">
            <div className="search-wrap">
              <Search size={17} className="search-icon" />
              <input type="text" placeholder="Search builds..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="search-input" />
              {!showResults && <Loader2 className="search-spinner" size={17} />}
            </div>

            {hasFilters && (
              <div className="active-filters">
                {activeCategory !== "All" && <span className="filter-chip">{activeCategory}<button onClick={() => setActiveCategory("All")} className="chip-x">×</button></span>}
                {(priceRange[0] > 0 || priceRange[1] < PRICE_MAX) && <span className="filter-chip">${priceRange[0].toFixed(0)}–${priceRange[1] >= PRICE_MAX ? `${PRICE_MAX}+` : priceRange[1].toFixed(0)}<button onClick={() => setPriceRange([0, PRICE_MAX])} className="chip-x">×</button></span>}
                {sortOrder !== "default" && <span className="filter-chip">{sortOrder === "low" ? "Low → High" : sortOrder === "high" ? "High → Low" : "Popular"}<button onClick={() => setSortOrder("default")} className="chip-x">×</button></span>}
                <button onClick={clearAll} className="clear-all">Clear all</button>
              </div>
            )}

            <p className="results-count">{displayedBuilds.length} {displayedBuilds.length === 1 ? 'build' : 'builds'} found</p>

            {!showResults ? (
              <div className="grid">
                {[1,2,3,4,5,6].map(i => (
                  <div key={i} className="skel"><div className="skel-img" /><div className="skel-body"><div className="skel-line skel-t" /><div className="skel-line" /><div className="skel-line skel-s" /></div></div>
                ))}
              </div>
            ) : displayedBuilds.length > 0 ? (
              <div className="grid">
                {displayedBuilds.map((b, idx) => {
                  const purchases = getPurchases(b.resourceId);
                  return (
                    <a key={b.id} href={b.link} target="_blank" rel="noreferrer" className="card" style={{ animationDelay: `${idx * 0.04}s` }}>
                      <div className="card-img-wrap">
                        <img src={b.imageUrl} alt={b.title} className="card-img" loading="lazy" />
                        <div className="card-img-ov" />
                        <div className="card-tags">{b.categories.map((c, i) => <span key={i} className="card-tag">{c}</span>)}</div>
                        {purchases !== null && purchases > 0 && (
                          <span className="card-sold">{purchases} sold</span>
                        )}
                      </div>
                      <div className="card-body">
                        <h3 className="card-title">{b.title}</h3>
                        <p className="card-desc">{b.description}</p>
                        <div className="card-foot">
                          <span className="card-price">${b.price.toFixed(2)}</span>
                          <span className="card-view">View <ExternalLink size={13} /></span>
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>
            ) : (
              <div className="empty">
                <div className="empty-icon"><Search size={22} /></div>
                <h3 className="empty-title">No builds found</h3>
                <p className="empty-desc">Try adjusting your filters or search term.</p>
                <button onClick={clearAll} className="empty-reset">Clear all filters</button>
              </div>
            )}
          </main>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-av"><img src={profileImageUrl} alt="Arrow Builds" /></div>
            <div><p className="footer-logo">ARROW<span className="accent">BUILDS</span></p><p className="footer-tag">Premium Minecraft Architecture</p></div>
          </div>
          <div className="footer-links">
            <a href={builtByBitLink} target="_blank" rel="noreferrer">BuiltByBit</a>
            <a href={discordLink} target="_blank" rel="noreferrer">Discord</a>
          </div>
        </div>
      </footer>

      <style dangerouslySetInnerHTML={{__html: `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Sora:wght@400;500;600;700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}html{scroll-behavior:smooth}
:root{--bg:#09090b;--bg2:#111113;--bg3:#151518;--bdr:#27272a;--bdr2:#3f3f46;--tx:#a1a1aa;--tx2:#71717a;--tx3:#52525b;--wh:#fafafa;--ac:#f97316;--ac2:#c2410c;--r:14px;--rs:8px;--fd:'Sora',sans-serif;--fb:'Outfit',sans-serif}
.app-root{min-height:100vh;background:var(--bg);color:var(--tx);font-family:var(--fb);overflow-x:hidden;-webkit-font-smoothing:antialiased}
.accent{color:var(--ac)}
.nav{position:fixed;top:0;left:0;right:0;z-index:100;padding:20px 0;border-bottom:1px solid transparent;transition:all .35s cubic-bezier(.4,0,.2,1)}
.nav--scrolled{padding:12px 0;background:rgba(9,9,11,.88);backdrop-filter:blur(16px) saturate(1.4);-webkit-backdrop-filter:blur(16px) saturate(1.4);border-bottom-color:var(--bdr)}
.nav-inner{max-width:1280px;margin:0 auto;padding:0 24px;display:flex;align-items:center;justify-content:space-between}
.logo-group{display:flex;align-items:center;gap:12px;text-decoration:none}
.logo-avatar{width:40px;height:40px;border-radius:10px;overflow:hidden;border:1px solid var(--bdr);background:var(--bg2);transition:border-color .2s}
.logo-group:hover .logo-avatar{border-color:var(--ac)}
.logo-avatar img{width:100%;height:100%;object-fit:cover;transform:scale(1.1)}
.logo-text{font-family:var(--fd);font-weight:800;font-size:20px;color:var(--wh);letter-spacing:-.5px}
.nav-links{display:flex;align-items:center;gap:32px}
.nav-link{font-size:13px;font-weight:600;color:var(--tx2);text-decoration:none;transition:color .2s}.nav-link:hover{color:var(--wh)}
.nav-cta{display:inline-flex;align-items:center;gap:6px;background:var(--ac);color:var(--wh);font-size:13px;font-weight:700;padding:8px 18px;border-radius:var(--rs);text-decoration:none;transition:background .2s,transform .15s}
.nav-cta:hover{background:var(--ac2);transform:translateY(-1px)}
.mobile-toggle{display:none;background:none;border:none;color:var(--tx);cursor:pointer;padding:4px}
.mobile-menu{display:none;position:absolute;top:100%;left:0;right:0;background:var(--bg2);border-bottom:1px solid var(--bdr);padding:20px 24px;flex-direction:column;gap:12px;transform-origin:top;transition:all .3s;transform:scaleY(0);opacity:0;pointer-events:none}
.mobile-menu--open{transform:scaleY(1);opacity:1;pointer-events:auto}
.mobile-menu-link{font-size:16px;font-weight:600;color:var(--tx);text-decoration:none;padding:8px 0}
.mobile-menu-cta{display:flex;align-items:center;justify-content:center;gap:8px;background:var(--ac);color:var(--wh);font-weight:700;padding:14px;border-radius:var(--rs);text-decoration:none;margin-top:8px}
@media(max-width:768px){.nav-links{display:none}.mobile-toggle{display:block}.mobile-menu{display:flex}}
.hero{position:relative;padding:180px 24px 80px;display:flex;justify-content:center;overflow:hidden}
.hero-bg{position:absolute;inset:0;z-index:0}
.hero-grain{position:absolute;inset:0;background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");background-repeat:repeat;opacity:.5}
.hero-glow{position:absolute;border-radius:50%;filter:blur(120px);opacity:.12}
.hero-glow--1{width:600px;height:600px;top:-200px;left:-100px;background:var(--ac)}
.hero-glow--2{width:500px;height:500px;bottom:-200px;right:-100px;background:#7c3aed}
.hero-grid{position:absolute;inset:0;background-size:48px 48px;background-image:linear-gradient(to right,rgba(255,255,255,.02) 1px,transparent 1px),linear-gradient(to bottom,rgba(255,255,255,.02) 1px,transparent 1px);mask-image:radial-gradient(ellipse 70% 60% at 50% 40%,black 20%,transparent 70%);-webkit-mask-image:radial-gradient(ellipse 70% 60% at 50% 40%,black 20%,transparent 70%)}
.hero-content{position:relative;z-index:1;max-width:720px;text-align:center;opacity:0;transform:translateY(24px);transition:all .8s cubic-bezier(.16,1,.3,1)}
.hero-content--visible{opacity:1;transform:translateY(0)}
.hero-badge{display:inline-flex;align-items:center;gap:8px;padding:6px 14px;border-radius:100px;background:var(--bg2);border:1px solid var(--bdr);font-size:11px;font-weight:700;color:var(--tx);letter-spacing:.6px;text-transform:uppercase;margin-bottom:32px}
.hero-badge-dot{width:6px;height:6px;border-radius:50%;background:var(--ac);box-shadow:0 0 8px var(--ac);animation:pulse 2s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(.8)}}
.hero-title{font-family:var(--fd);font-weight:900;font-size:clamp(40px,7vw,72px);line-height:1.05;letter-spacing:-2.5px;color:var(--wh);margin-bottom:24px}
.hero-title-line{display:block}
.hero-title-accent{background:linear-gradient(135deg,var(--ac) 0%,#fb923c 50%,#fbbf24 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.hero-subtitle{font-size:17px;line-height:1.7;color:var(--tx2);max-width:520px;margin:0 auto 36px}
.hero-actions{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-bottom:56px}
.btn{display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border-radius:var(--rs);font-family:var(--fb);font-weight:700;font-size:14px;text-decoration:none;cursor:pointer;border:none;transition:all .2s cubic-bezier(.4,0,.2,1)}
.btn--primary{background:var(--wh);color:var(--bg)}.btn--primary:hover{background:#d4d4d8;transform:translateY(-1px)}
.btn--ghost{background:transparent;color:var(--tx);border:1px solid var(--bdr)}.btn--ghost:hover{border-color:var(--bdr2);color:var(--wh);background:var(--bg2)}
.hero-stats{display:flex;align-items:center;justify-content:center;gap:36px;flex-wrap:wrap}
.stat-item{display:flex;flex-direction:column;align-items:center;gap:4px}
.stat-number{font-family:var(--fd);font-weight:800;font-size:28px;color:var(--wh);letter-spacing:-1px}
.stat-label{font-size:12px;color:var(--tx3);font-weight:500;letter-spacing:.3px}
.stat-divider{width:1px;height:36px;background:var(--bdr)}
@media(max-width:640px){.hero{padding:140px 16px 60px}.hero-stats{gap:24px}.stat-divider{display:none}}
.trust-bar{overflow:hidden;border-top:1px solid var(--bdr);border-bottom:1px solid var(--bdr);background:var(--bg2);padding:14px 0}
.trust-track{display:flex;width:max-content;animation:tscroll 35s linear infinite}
.trust-track:hover{animation-play-state:paused}
.trust-set{display:flex;align-items:center;gap:24px;padding:0 24px}
.trust-item{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:var(--tx2);white-space:nowrap}
.trust-item svg{color:var(--ac)}.trust-sep{color:var(--tx3);font-size:8px}
@keyframes tscroll{0%{transform:translateX(0)}100%{transform:translateX(-33.333%)}}
.store{padding:72px 24px 80px;scroll-margin-top:80px}
.store-inner{max-width:1280px;margin:0 auto;display:flex;gap:40px}
.sidebar{width:240px;flex-shrink:0}
.sidebar-card{position:sticky;top:90px;background:var(--bg2);border:1px solid var(--bdr);border-radius:var(--r);padding:24px}
.sidebar-heading{display:flex;align-items:center;gap:8px;font-size:11px;font-weight:700;color:var(--tx3);text-transform:uppercase;letter-spacing:1px;margin-bottom:14px}
.sidebar-section{margin-top:24px;padding-top:20px;border-top:1px solid var(--bdr)}
.category-list{display:flex;flex-direction:column;gap:2px}
.category-btn{display:flex;align-items:center;justify-content:space-between;background:none;border:none;cursor:pointer;padding:8px 12px;border-radius:var(--rs);font-family:var(--fb);font-size:13px;font-weight:600;color:var(--tx2);transition:all .15s;text-align:left;width:100%}
.category-btn:hover{background:rgba(255,255,255,.04);color:var(--tx)}
.category-btn--active{background:rgba(249,115,22,.08);color:var(--ac)}
.cat-count{font-size:11px;font-weight:700;color:var(--tx3);min-width:20px;text-align:right}
.category-btn--active .cat-count{color:var(--ac)}
.price-display{display:flex;align-items:center;gap:8px;margin-bottom:16px}
.price-badge{padding:4px 10px;border-radius:6px;background:rgba(255,255,255,.04);border:1px solid var(--bdr);font-size:13px;font-weight:700;color:var(--wh);font-family:var(--fd);letter-spacing:-.3px}
.price-sep{color:var(--tx3);font-size:12px}
.range-row{margin-bottom:10px}
.range-label{display:block;font-size:11px;font-weight:600;color:var(--tx3);margin-bottom:6px;letter-spacing:.3px}
.range-slider{-webkit-appearance:none;appearance:none;width:100%;height:4px;border-radius:4px;background:var(--bdr);outline:none;cursor:pointer}
.range-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:var(--ac);border:2px solid var(--bg);box-shadow:0 0 0 2px rgba(249,115,22,.3);cursor:pointer;transition:box-shadow .15s}
.range-slider::-webkit-slider-thumb:hover{box-shadow:0 0 0 4px rgba(249,115,22,.2)}
.range-slider::-moz-range-thumb{width:16px;height:16px;border-radius:50%;background:var(--ac);border:2px solid var(--bg);cursor:pointer}
.sort-group{display:flex;flex-direction:column;gap:2px}
.sort-btn{background:none;border:none;cursor:pointer;padding:7px 12px;border-radius:var(--rs);font-family:var(--fb);font-size:12px;font-weight:600;color:var(--tx2);transition:all .15s;text-align:left;width:100%}
.sort-btn:hover{background:rgba(255,255,255,.04);color:var(--tx)}
.sort-btn--active{background:rgba(249,115,22,.08);color:var(--ac)}
.sidebar-footer{margin-top:24px;padding-top:20px;border-top:1px solid var(--bdr)}
.sidebar-footer-label{font-size:11px;color:var(--tx3);font-weight:600;margin-bottom:10px;text-transform:uppercase;letter-spacing:.5px}
.sidebar-footer-btn{display:block;text-align:center;padding:10px;border-radius:var(--rs);background:rgba(255,255,255,.04);border:1px solid var(--bdr);color:var(--tx);font-size:13px;font-weight:600;text-decoration:none;transition:all .2s}
.sidebar-footer-btn:hover{background:rgba(255,255,255,.07);border-color:var(--bdr2);color:var(--wh)}
@media(max-width:900px){
  .store-inner{flex-direction:column}.sidebar{width:100%}.sidebar-card{position:static}
  .category-list{flex-direction:row;flex-wrap:wrap;gap:6px}
  .category-btn{padding:6px 14px;border-radius:100px;border:1px solid var(--bdr);font-size:12px;width:auto}
  .category-btn--active{border-color:var(--ac)}.cat-count{display:none}
  .sidebar-footer{display:none}
}
.active-filters{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:14px}
.filter-chip{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:100px;background:rgba(249,115,22,.08);border:1px solid rgba(249,115,22,.2);font-size:12px;font-weight:600;color:var(--ac)}
.chip-x{background:none;border:none;cursor:pointer;color:var(--ac);font-size:14px;line-height:1;padding:0;margin-left:2px;opacity:.6;transition:opacity .15s}.chip-x:hover{opacity:1}
.clear-all{background:none;border:none;cursor:pointer;font-family:var(--fb);font-size:12px;font-weight:600;color:var(--tx3);transition:color .15s}.clear-all:hover{color:var(--tx)}
.results-count{font-size:12px;font-weight:600;color:var(--tx3);margin-bottom:16px;letter-spacing:.2px}
.catalog{flex:1;min-width:0}
.search-wrap{position:relative;margin-bottom:20px}
.search-icon{position:absolute;left:16px;top:50%;transform:translateY(-50%);color:var(--tx3);pointer-events:none}
.search-input{width:100%;background:var(--bg2);border:1px solid var(--bdr);color:var(--wh);padding:13px 48px 13px 46px;border-radius:var(--r);font-family:var(--fb);font-size:14px;outline:none;transition:border-color .2s}
.search-input::placeholder{color:var(--tx3)}.search-input:focus{border-color:var(--bdr2)}
.search-spinner{position:absolute;right:16px;top:50%;transform:translateY(-50%);color:var(--tx3);animation:spin .8s linear infinite}
@keyframes spin{to{transform:translateY(-50%) rotate(360deg)}}
.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:18px}
.card{display:flex;flex-direction:column;background:var(--bg3);border:1px solid var(--bdr);border-radius:var(--r);overflow:hidden;text-decoration:none;color:inherit;transition:all .3s cubic-bezier(.4,0,.2,1);animation:cin .4s ease-out both}
.card:hover{border-color:var(--bdr2);transform:translateY(-4px);box-shadow:0 20px 40px -12px rgba(0,0,0,.5),0 0 0 1px var(--bdr2)}
@keyframes cin{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.card-img-wrap{position:relative;aspect-ratio:16/10;overflow:hidden;background:var(--bg)}
.card-img{width:100%;height:100%;object-fit:cover;transition:transform .5s cubic-bezier(.4,0,.2,1);opacity:.88}
.card:hover .card-img{transform:scale(1.06);opacity:1}
.card-img-ov{position:absolute;inset:0;background:linear-gradient(to top,var(--bg3) 0%,transparent 50%)}
.card-tags{position:absolute;top:10px;left:10px;display:flex;gap:5px;flex-wrap:wrap}
.card-tag{padding:3px 9px;border-radius:6px;background:rgba(9,9,11,.78);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.06);font-size:10px;font-weight:700;color:var(--tx);letter-spacing:.3px;text-transform:uppercase}
.card-sold{position:absolute;top:10px;right:10px;padding:3px 9px;border-radius:6px;background:rgba(9,9,11,.78);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.06);font-size:10px;font-weight:700;color:var(--ac)}
.card-body{padding:18px;flex:1;display:flex;flex-direction:column}
.card-title{font-family:var(--fd);font-weight:700;font-size:15px;color:var(--wh);margin-bottom:6px;line-height:1.3;letter-spacing:-.3px;transition:color .2s}
.card:hover .card-title{color:var(--ac)}
.card-desc{font-size:12.5px;color:var(--tx2);line-height:1.55;flex:1;margin-bottom:14px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.card-foot{display:flex;align-items:center;justify-content:space-between;padding-top:12px;border-top:1px solid var(--bdr)}
.card-price{font-family:var(--fd);font-weight:800;font-size:18px;color:var(--wh);letter-spacing:-.5px}
.card-view{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:700;color:var(--tx2);padding:5px 12px;border-radius:6px;background:rgba(255,255,255,.04);border:1px solid var(--bdr);transition:all .2s}
.card:hover .card-view{color:var(--wh);background:rgba(255,255,255,.07);border-color:var(--bdr2)}
.skel{background:var(--bg3);border:1px solid var(--bdr);border-radius:var(--r);overflow:hidden}
.skel-img{aspect-ratio:16/10;background:var(--bg2);animation:shim 1.5s infinite}
.skel-body{padding:18px;display:flex;flex-direction:column;gap:10px}
.skel-line{height:12px;background:var(--bg2);border-radius:6px;animation:shim 1.5s infinite}
.skel-t{height:14px;width:75%}.skel-s{width:50%}
@keyframes shim{0%{opacity:.4}50%{opacity:.7}100%{opacity:.4}}
.empty{text-align:center;padding:80px 24px;background:var(--bg2);border:1px solid var(--bdr);border-radius:var(--r)}
.empty-icon{width:52px;height:52px;margin:0 auto 16px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(255,255,255,.04);color:var(--tx3)}
.empty-title{font-family:var(--fd);font-size:18px;font-weight:700;color:var(--wh);margin-bottom:8px}
.empty-desc{font-size:13px;color:var(--tx2);margin-bottom:20px}
.empty-reset{background:none;border:none;cursor:pointer;color:var(--ac);font-family:var(--fb);font-size:13px;font-weight:700}.empty-reset:hover{color:var(--ac2)}
.footer{border-top:1px solid var(--bdr);background:var(--bg)}
.footer-inner{max-width:1280px;margin:0 auto;padding:28px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:20px}
.footer-brand{display:flex;align-items:center;gap:14px}
.footer-av{width:36px;height:36px;border-radius:8px;overflow:hidden;border:1px solid var(--bdr);background:var(--bg2)}
.footer-av img{width:100%;height:100%;object-fit:cover;filter:grayscale(1);transition:filter .3s}.footer-av:hover img{filter:grayscale(0)}
.footer-logo{font-family:var(--fd);font-weight:800;font-size:15px;color:var(--wh);letter-spacing:-.3px}
.footer-tag{font-size:11px;color:var(--tx3);margin-top:2px}
.footer-links{display:flex;gap:28px}
.footer-links a{font-size:12px;font-weight:600;color:var(--tx3);text-decoration:none;transition:color .2s}.footer-links a:hover{color:var(--tx)}
@media(max-width:640px){.hero-title{letter-spacing:-1.5px}.hero-actions{flex-direction:column;align-items:center}.btn{width:100%;max-width:320px;justify-content:center}.grid{grid-template-columns:1fr}.store{padding:48px 16px 60px}.footer-inner{flex-direction:column;text-align:center}.footer-brand{flex-direction:column}.footer-links{gap:20px}}
      `}} />
    </div>
  );
}
